import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import LogoHeader from "../../../../components/common/LogoHeader";
import PayrollHeaderDisplay from "../../../../components/PayrollHeader/PayrollHeaderDisplay";
import { preparePayrollHeaderForPrint } from "../../../../utils/printImageUtils";
import { findObjectUseCase } from "../../../../usecases/object";

class ViewPayrollFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

   _renderDateRange = (object, year) => {
    if (object.startDate && object.endDate) {
      const endDate = year ? `${object.endDate}, ${year}` : object.endDate;
      return (
        <>
          {object.startDate} <i className="bi bi-arrow-right-short" />{" "}
          {endDate}
        </>
      );
    }
    return object.startDate || object.endDate || "";
  };

  async fetchPayrollData (payrollID){
      return await findObjectUseCase().execute("payroll", {
        where: {
          payrollID
        }
      });
  }

  _renderPayrollTrail = (object) => {
    const parts = [object.payrollType, object.jobType, object.payItem].filter(
      Boolean
    );

    return parts.map((part, index) => (
      <span key={index}>
        {index > 0 && <i className="bi bi-arrow-right-short mx-1" />}
        {part}
      </span>
    ));
  };

  _renderLogoHeader = (payrollHeader) => {
    const displayHeader = preparePayrollHeaderForPrint(
      payrollHeader?.value?.header
    );

    return (
      <div
        style={{
          width: "100%",
          opacity: 0,
          animation: "fadeIn 0.3s ease-in-out forwards",
        }}
      >
        {displayHeader ? (
          <PayrollHeaderDisplay header={displayHeader} />
        ) : (
          <div className="d-flex justify-content-center flex-column align-items-center flex-md-row">
            <LogoHeader
              logoSrc="/BIR.png"
              rightLogoSrc="/bagong_pilipinas.png"
              altText="Print Logo"
              mainLabel="Republic Of the Philippines"
              subLabel="BUREAU OF IMMIGRATION"
              description="Patriotism * Integrity * Professionalism"
            />
          </div>
        )}
      </div>
    );
  };

  _onSignatoryChange = (section, value) => {
    this.view.setState((prevState) => ({
      signatories: {
        ...prevState.signatories,
        [section]: value,
      },
    }));
  };
}

export default ViewPayrollFormPresenter;
